import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { InviteUserInput, UserInfo } from "../../../types";
import { userService } from "../../../services/userService";

const normalizeEmail = (value: string): string => {
  return value.trim().toLowerCase();
};

export const useInviteUser = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (user: InviteUserInput) => {
      return userService.invite(user);
    },
    onSuccess: (invited) => {
      qc.setQueryData<UserInfo[]>(["users"], (current = []) => {
        const alreadyExists = current.some((user) => {
          return normalizeEmail(user.email) === normalizeEmail(invited.email);
        });
        if (alreadyExists) {
          return current;
        }
        return [...current, invited];
      });
      qc.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
